// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__FhQ6K","tagline":"style__tagline__Bzcg2","copyright":"style__copyright__qSZdz"};